/*eslint-disable*/

import React, {
	ReactNode,
	useContext,
	useEffect,
	useRef,
	useState,
} from "react";
import "../../components/DoctaChatBox/index.css";
import { Collapse, Spin, Typography, Card, Button, Modal } from "antd";
import type { CollapseProps } from "antd";
import {
	PlusCircleOutlined,
	MinusCircleFilled,
	FullscreenExitOutlined,
	FullscreenOutlined,
	RightOutlined,
	ShareAltOutlined,
	CopyOutlined,
	LeftOutlined,
} from "@ant-design/icons";
import "./index.css";
import AvatarUser from "../../../static/icon/AvatarUser.svg";
import { Image } from "react-bootstrap";
import MyContext from "../Mycontext";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../providers/CustomThemeProvider";
import MoreDataBtn from "../MoreDataBtn";
import { SendQAFeedback } from "../../../api/Api";

import contentPaste from "../../../static/icon/content_paste.svg";
import lightContentPaste from "../../../static/light-icon/content_paste.svg";
import thumbup from "../../../static/icon/thumbs_up_icon.svg";
import lightThumbup from "../../../static/light-icon/thumbs_up_icon.svg";
import thumbdown from "../../../static/icon/thumbs_down_icon.svg";
import lightThumbdown from "../../../static/light-icon/thumbs_down_icon.svg";
import filledThumbup from "../../../static/icon/filled_thumbs_up_icon.svg";
import filledLightThumbup from "../../../static/light-icon/filled_thumbs_up_icon.svg";
import filledThumbdown from "../../../static/icon/filled_down_thumbs_icon.svg";
import filledLighthumbdown from "../../../static/light-icon/filled_down_thumbs_icon.svg";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

interface IProps {
	type: string | number;
	refreshCallback: () => void;
	scrollBoxRef?: any;
	isStream?: boolean;
	data?: any;
	showThumb?: boolean;
}

export const QAStatus = {
	GOOD: "good",
	BAD: "bad",
};

export const checkIsJSON = (str: string | object): boolean => {
	if (typeof str == "string") {
		try {
			const obj = JSON.parse(str);
			if (typeof obj == "object" && obj) {
				return true;
			} else {
				return false;
			}
		} catch (e) {
			return false;
		}
	}
	return false;
};

export const copyConter = (text: string) => {
	const textarea = document.createElement("textarea");
	textarea.value = text;
	// 将textarea添加到DOM中并选中文本
	document.body.appendChild(textarea);
	textarea.select();
	// 复制文本到剪切板
	const successful = document.execCommand("copy");
	// 清理临时元素
	document.body.removeChild(textarea);
	toast.success("Copy successful.");
	return successful;
};

const NormalDoctaChatBox = (props: IProps) => {
	const {
		refreshCallback,
		scrollBoxRef,
		isStream = false,
		data,
		showThumb = false,
	} = props;
	const [qdDisplay, setQdDisplay] = useState<CollapseProps["items"]>([]);
	const [stringData, setStringData] = useState<string>("");
	const [combinedMessage, setCombinedMessage] = useState<string>("");
	const [subfixMessage, setSubfixMessage] = useState<string>("");
	const { t, i18n } = useTranslation();
	const [stData, setStData] = useState<any>(null);
	const [st, setSt] = useState<any>(null);
	const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
	const [isFullScreenIdx, setIsFullScreenIdx] = useState<number>(-1);
	const [fullScreenItem, setFullScreenItem] = useState<any>(null);

	const scrollContainerRef = useRef<HTMLDivElement>(null);
	const [isAtEnd, setIsAtEnd] = useState(false);
	const [isAtStart, setIsAtStart] = useState(true);

	const scrollToEnd = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollTo({
				left: scrollContainerRef.current.scrollWidth,
				behavior: "smooth", // 平滑滚动
			});
		}
	};

	const scrollToStart = () => {
		scrollContainerRef.current?.scrollTo({
			left: 0,
			behavior: "smooth",
		});
	};

	const toggleFullScreen = (index: any) => {
		setIsFullScreenIdx(index);
		setIsFullScreen(!isFullScreen);
	};

	// QA反馈
	const [qaStatus, setQaStatus] = useState<string>("");

	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const { selectedChat, requireType, current, save, setCurrent } = context;
	const { isDarkMode } = useTheme();
	const panelStyle: React.CSSProperties = {
		marginBottom: 10,
		background: isDarkMode
			? "rgba(246, 246, 246, 0.29)"
			: "rgba(246, 246, 246, 0.7)",

		borderRadius: 15,
		border: "none",
	};

	// 判断是否已经滚动到最右侧
	const checkIfAtEnd = () => {
		if (scrollContainerRef.current) {
			const { scrollLeft, scrollWidth, clientWidth } =
				scrollContainerRef.current;

			setIsAtStart(scrollLeft <= 0);
			setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);

			// if (scrollLeft + clientWidth >= scrollWidth) {
			// 	setIsAtEnd(true);
			// } else {
			// 	setIsAtEnd(false);
			// }
		}
	};

	// 监听滚动事件
	const handleScroll = () => {
		checkIfAtEnd();
	};

	useEffect(() => {
		// 初始检查是否在最右端
		checkIfAtEnd();

		// 监听滚动事件
		const container = scrollContainerRef.current;
		container?.addEventListener("scroll", handleScroll);

		return () => {
			container?.removeEventListener("scroll", handleScroll);
		};
	}, [selectedChat]);

	const pushData = (
		qdData: any,
		item: any,
		indexOuter: number,
		displayList: CollapseProps["items"]
	) => {
		const system = qdData[item]?.system;
		const instruction = qdData[item]?.instruction;
		const response = qdData[item]?.response;

		displayList?.push({
			key: indexOuter,
			label: item,
			style: panelStyle,
			children: (
				<div className="dataset-wrapper">
					{system && system}
					<div className="qa-response-title">数据 {indexOuter + 1}</div>
					<div className="response-wrapper hidden-scrollbar">
						{instruction?.map((item: string, index: number) => {
							return (
								<div className="qa-response " key={index}>
									<div className="qa-response-content">
										<div className="qa-response-content-left">Instruction:</div>
										<div className="qa-response-content-right">
											{item?.replace("Instruction:", "")}
										</div>
										{/* </div>

								<div className="qa-response-content"> */}
										<div className="qa-response-content-left">Response:</div>
										<div className="qa-response-content-right">
											{response?.[index]?.replace("Response:", "")}
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			),
		});
	};

	const sendFeedback = async (likeDislike: number) => {
		/* eslint-disable  @typescript-eslint/no-explicit-any */
		const context = {} as any;
		stData?.map((item: any) => {
			context[item.name] = item.data;
		});
		const params = {
			likeDislike: likeDislike,
			context: context,
		};

		await SendQAFeedback(params);
	};

	const handleCancel = () => {
		setIsFullScreen(false);
	};

	useEffect(() => {
		let latestMessage = data;

		if (checkIsJSON(latestMessage)) {
			latestMessage = JSON.parse(latestMessage);

			// parse Query data
			let qdData = latestMessage as any;

			if (qdData?.data) {
				qdData = qdData?.data;
			} else if (qdData?.[0]) {
				qdData = JSON.parse(qdData?.[0]);
			}

			console.log("=========== ", qdData);

			setStData(qdData);
			setSt(latestMessage);

			if (typeof qdData?.single_message == "string") {
				// setMessage(qdData?.single_message);
				setStringData(qdData?.single_message);

				return;
			}
			if (qdData?.prefix_data_message && qdData?.prefix_data_message != "") {
				requireType != "img" && setCombinedMessage(qdData?.prefix_data_message);
			}

			if (qdData?.subfix_data_message && qdData?.subfix_data_message != "") {
				requireType != "img" && setSubfixMessage(qdData?.subfix_data_message);
			}

			setStringData("");
			if (qdData?.img_list?.length > 0) {
				refreshCallback();
				return;
			}

			if (qdData && typeof qdData === "object" && !Array.isArray(qdData)) {
				const displayList: CollapseProps["items"] = [];
				let cnt = 0;

				Object.keys(qdData).map((item, index) => {
					if (
						!(
							process.env.REACT_APP_ENV === "production" &&
							item.startsWith("ChatGPT returns")
						)
					) {
						if (
							item != "prefix_data_message" &&
							item != "subfix_data_message" &&
							item != "error"
						) {
							if (typeof qdData[item] === "object") {
								pushData(qdData, item, cnt, displayList);
								cnt += 1;
							} else {
								displayList.push({
									key: cnt,
									label: item,
									children: qdData[item],
									style: panelStyle,
								});
							}
						}
					}
				});
				setQdDisplay(displayList as any);
			}
		} else {
			setStringData(data);
		}
	}, [data]);

	return (
		<>
			<Modal
				open={isFullScreen}
				// onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
				width={"100vw"}
				className={"fullscreen-card"}
				// bodyStyle={{ height: "calc(100vh-70px-53px)" }}
				bodyProps={{ height: "100vh" }}
			>
				<Card
					style={{
						overflowY: "scroll",
						width: "100%",
					}}
					// @ts-ignore
					variant="borderless"
					className={`hidden-scrollbar data-card-full`}
				>
					<>{fullScreenItem && fullScreenItem.children} </>
				</Card>
			</Modal>

			<div className="streaming">
				{requireType != "img" && (
					<div
						className={"chatList-item"}
						key={`${selectedChat?.messages?.length ?? 1}`}
						id={`${selectedChat?.messages?.length ?? 1}`}
					>
						{/* <div className="chatList-item-img">
							<Image src={AvatarUser} />
						</div> */}
						<div className="chatList-item-user">
							{/* <div className="chatList-item-user-name">
								{i18n.language == "en" ? "DOCTA" : "第五维度"}
							</div> */}
							<div className="chatList-item-box-wrapper">
								<div className="chatList-item-dialog-box-ai">
									<div className="qdData-color">
										{stringData != "" ? (
											stringData
										) : (
											<>
												<p className="qdData-color-title">
													<Typography>
														<blockquote>
															{combinedMessage != "" && combinedMessage}
														</blockquote>
													</Typography>
												</p>

												<div className="data-card-wrapper">
													<div
														className={`scroll-container ${
															!isAtEnd ? "with-gradient" : ""
														}  ${!isAtStart ? "with-left-gradient" : ""}`}
													>
														{/* 左侧渐变 + 按钮 */}
														{!isAtStart && (
															<>
																<button
																	className="scroll-button-left"
																	onClick={scrollToStart}
																>
																	<LeftOutlined />
																</button>
															</>
														)}

														<div
															className="scroll-content"
															ref={scrollContainerRef}
														>
															{qdDisplay?.map((item: any, index: number) => {
																return (
																	<div className="single-card-wrapper">
																		<Card
																			// @ts-ignore
																			variant="borderless"
																			className={`hidden-scrollbar data-card`}
																		>
																			<div>{item.children}</div>
																		</Card>
																		<div className="single-card-wrapper-footer">
																			{/* <div className="footer-left">
																				<Button type="text" onClick={() => {}}>
																					<ShareAltOutlined />
																				</Button>
																				<Button type="text" onClick={() => {}}>
																					<CopyOutlined />
																				</Button>
																			</div> */}
																			<div className="footer-right">
																				<Button
																					type="text"
																					onClick={() => {
																						toggleFullScreen(index);
																						setFullScreenItem(item);
																					}}
																				>
																					{isFullScreen ? (
																						<FullscreenExitOutlined />
																					) : (
																						<FullscreenOutlined />
																					)}
																				</Button>
																			</div>
																		</div>
																	</div>
																	// </Collapse.Panel>
																);
															})}

															{!isAtEnd && (
																<>
																	<button
																		className="scroll-button"
																		onClick={scrollToEnd}
																	>
																		<RightOutlined />
																	</button>
																</>
															)}
														</div>
													</div>
													{/* </Collapse> */}
													<Typography>
														<blockquote>
															{subfixMessage != "" ? subfixMessage : <></>}
														</blockquote>
													</Typography>
												</div>
											</>
										)}
									</div>

									<div className="box-footer">
										{st?.return_type != "single_message" && (
											<MoreDataBtn data={st} />
										)}
										{showThumb && (
											<>
												<Image
													src={
														isDarkMode
															? qaStatus === QAStatus.GOOD
																? filledThumbup
																: thumbup
															: qaStatus === QAStatus.GOOD
															? filledLightThumbup
															: lightThumbup
													}
													className="thumbup-btn"
													onClick={() => {
														setQaStatus(QAStatus.GOOD);
														sendFeedback(1);
													}}
												/>
												<Image
													src={
														isDarkMode
															? qaStatus === QAStatus.BAD
																? filledThumbdown
																: thumbdown
															: qaStatus === QAStatus.BAD
															? filledLighthumbdown
															: lightThumbdown
													}
													className="thumbdown-btn"
													onClick={() => {
														setQaStatus(QAStatus.BAD);
														sendFeedback(-1);
													}}
												/>
											</>
										)}
										<Image
											src={isDarkMode ? contentPaste : lightContentPaste}
											className="copy-btn"
											onClick={() => {
												// const obj = JSON.parse(stData)?.data;
												const obj = stData;

												const copyText = Object.keys(obj).reduce(
													(acc: any, key: any) => {
														if (key.startsWith("Data")) {
															acc[key] = obj[key];
														}
														return acc;
													},
													{}
												);

												copyConter(JSON.stringify(copyText));
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default NormalDoctaChatBox;
